import { navigate } from 'gatsby'
import classNames from 'classnames'
import Text from 'components/Text'
import Button from 'components/Button'
import router from 'utils/router'
import useOriginTheme from 'hooks/useOriginTheme'
import './LandingFeatures.styl'

const LandingFeatures = ({ blok, location }) => {
  const { isRecoveryOrigin } = useOriginTheme()

  const renderItems = () => {
    return blok.list_features.map((i, index) => (
      <div className="item" key={index}>
        <Text p className="item-number" aria-hidden="true">
          {index + 1}.
        </Text>
        <Text p className="item-text">
          {/* this span element is only used for screen reader */}
          <span className="sr-only">{`${index + 1}:`}</span>{' '}
          <b> {i.bold_text}</b>
          {` ${i.normal_text}`}
        </Text>
      </div>
    ))
  }

  const featuresClassnames = classNames('landing-features', {
    'landing-features__generalTheme': !isRecoveryOrigin,
  })

  return (
    <div className={featuresClassnames}>
      <Text h2 className="features-top-part">
        {blok.title}
      </Text>
      <div className="features-middle-part">{renderItems()}</div>
      <div className="features-bottom-part">
        <Button
          className="button"
          onClick={() => {
            if (typeof window !== 'undefined') {
              window.onbeforeunload = null
            }
            navigate('/registro', {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
          data-unique="62229237-1f4b-461b-b8d0-fe96431ecc0c"
        >
          {blok.button_text}
        </Button>
      </div>
    </div>
  )
}

export default LandingFeatures
